module.exports = __webpack_public_path__ + "img/followup-1.9ba14962.png";